import styled, { css } from "styled-components";

export const AccountWrapper = styled.div`
  & #accountMenu {
    width: 300px;
    top: 100%;
    z-index: 99;
    box-shadow: 0 0 20px 0 rgb(0 0 0 / 15%);
    border: 1px solid rgba(226, 226, 226, 1);
    ${({ theme: { isRTL } }) => (isRTL ? "left:0" : "right:0")}
  }

  & .profileArrow {
    ${({ theme }) =>
      theme.isLTR
        ? css`
            transform: rotate(0deg);
          `
        : css`
            transform: rotate(180deg);
          `}
  }

  & #accountMenu svg {
    margin: 0 8px;
  }

  & #accountMenu > div:first-child a {
    border: 1px solid #f2f2f7;
  }

  .subList { {
    padding-${({ theme: { isRTL } }) => (isRTL ? "right" : "left")}: 30px
  }
  }

  & .accountList, & .accountList a, #accountMenu button {
    color: #5e6278;
  }

  .subList a:last-child {
    padding-bottom: 16px;
  }

  & .accountList a:hover, & #accountMenu button:hover, & .accountList div.selected, & #accountMenu .subMenuTitle:hover {
    color: #0179ff;
    background-color: #f4f6fa
  }

  & .accountList div.selected .subMenuArrow path, & #accountMenu .subMenuTitle:hover .subMenuArrow path {
    fill: #0179ff
  }

  & .subList a:before {
    content: ".";
    display: inline-block;
    margin-left: 5px;
    font-size: 40px;
    position: relative;
    top: -3px;
  }

  & #logout-svg {
    ${({ theme }) =>
      theme.isRTL &&
      css`
        transform: rotate(180deg);
      `}
  }

  & #myListFooter {
    strong {
      color: #000;
    }

    strong:hover {
      color: #000;
    }
  }

  & #accountMenu span {
    width: 38px;
  }

  .membership_type {
    color: #3B8324;
    background-color: #ECFEF4;
    width: fit-content;
    padding: 8px 10px;
  }

`;

export const ShimmerLogin = styled.div`
  height: 45px;
  min-width: 150px;
`;
